import React, { useEffect, useState, useCallback } from "react";
import { ethers } from "ethers";

const TokenBalance = ({ provider, account }) => {
    const [kaia, setKaia] = useState("0");
    const [gold, setGold] = useState("0");
    const [silver, setSilver] = useState("0");

    const goldAddress = process.env.REACT_APP_GOLD_ADDRESS;
    const silverAddress = process.env.REACT_APP_SILVER_ADDRESS;
    const ERC20_ABI = ["function balanceOf(address) view returns (uint256)"];

    const fetchBalances = useCallback(async () => {
        if (!provider || !account) return;

        const kaiaBalance = await provider.getBalance(account);
        setKaia(ethers.formatEther(kaiaBalance));

        const goldToken = new ethers.Contract(goldAddress, ERC20_ABI, provider);
        const silverToken = new ethers.Contract(silverAddress, ERC20_ABI, provider);

        const goldBalance = await goldToken.balanceOf(account);
        const silverBalance = await silverToken.balanceOf(account);

        setGold(ethers.formatEther(goldBalance));
        setSilver(ethers.formatEther(silverBalance));
    }, [provider, account, goldAddress, silverAddress]);

    useEffect(() => {
        fetchBalances();
    }, [fetchBalances]);

    return (
        <div>
            <h3>내 잔액</h3>
            <div>Kaia: {kaia}</div>
            <div>Gold: {gold}</div>
            <div>Silver: {silver}</div>
        </div>
    );
};

export default TokenBalance;
